// extracted by mini-css-extract-plugin
module.exports = {"conditions":"KkBPJDoP","conditionItem":"lBsbvRHs"};